/** Canonical consumable criticality values (UI dropdown + API payload). */
export const CONSUMABLE_CRITICALITY_VALUES = ['Critical', 'Medium', 'Normal'];

export const CONSUMABLE_CRITICALITY_OPTIONS = CONSUMABLE_CRITICALITY_VALUES.map((value) => ({
  value,
  label: value,
}));

/**
 * Normalize API / legacy / form strings to Critical | Medium | Normal.
 * Maps legacy High → Critical and Low → Normal so UI and API stay aligned.
 */
export function normalizeConsumableCriticality(value) {
  if (value == null || value === '') return '';
  const low = String(value).trim().toLowerCase();
  if (low === 'critical' || low === 'high') return 'Critical';
  if (low === 'medium') return 'Medium';
  if (low === 'normal' || low === 'low') return 'Normal';
  return '';
}

/** Canonical value for API payloads, or undefined when empty/invalid. */
export function consumableCriticalityForApi(value) {
  const normalized = normalizeConsumableCriticality(value);
  return normalized || undefined;
}

/** Display label for tables; falls back to em dash when unset. */
export function formatConsumableCriticalityLabel(value, fallback = '—') {
  const normalized = normalizeConsumableCriticality(value);
  return normalized || fallback;
}
